<template>
  <div
    class="sb-action"
    data-sb-automation="sb-action"
    data-sb-regression="sb-action"
    :class="{ 'sb-action--disabled': disabled }"
    @click="doAction"
  >
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </div>
</template>

<script>
/**
 * Helper component to be used inside sb-options.
 * This is a single option row in sb-options.
 */
export default {
  name: 'SbAction',
  inject: {
    SbActionList: {
      default: { actions: [] },
    },
  },
  props: {
    /**
     * Value of the dropdown option. When selected, this will be the value(s) of the dropdown.
     */
    value: {
      type: [Number, String, Object],
      required: true,
    },
    /**
     * If the action button is disabled.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.SbActionList?.hasProvidedActions) this.registerAction();
  },
  methods: {
    doAction() {
      if (this.disabled || !this.SbActionList?.triggerAction) return;
      this.SbActionList?.triggerAction(this.value);
    },
    registerAction() {
      this.SbActionList?.actions?.push(this.value);
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@src/components/ActionList/style/sb-action.scss';
</style>
